// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[5].use[1]!./TooltipTokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable property-disallowed-list -- DS component */

.Tooltip-module__Container__j9s42 {
    z-index: var(--ds-tooltip-z-index);
    min-width: var(--ds-24x);
    max-width: var(--ds-80x);
    padding: var(--ds-m);
    background-color: var(--ds-tooltip-bg-color);
    border-radius: var(--ds-border-radius-s);
}

.Tooltip-module__Arrow__OwVc0 {
    fill: var(--ds-tooltip-bg-color);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Tooltip-module__Container__j9s42`,
	"Arrow": `Tooltip-module__Arrow__OwVc0`
};
export default ___CSS_LOADER_EXPORT___;
